<template>
  <section>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 影片</h3>
        <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'TI000411' } }"
          >
            1. 放生與護生（動畫）
            <b-icon icon="camera-video" font-scale="2"></b-icon>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'TI000041' } }"
          >
            2. 為什麼不能吃它們
            <b-icon icon="camera-video" font-scale="2"></b-icon>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'TI000042' } }"
          >
            3. 試用活魚袋放生心得報告
            <b-icon icon="camera-video" font-scale="2"></b-icon>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'TI000166' } }"
          >
            4. 生命的吶喊
            <b-icon icon="camera-video" font-scale="2"></b-icon>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>● 開示</h3>
        <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'TI000016' } }"
          >
            1. 殺生的果報是什麼／淨空法師　主講
            <b-icon icon="music-player" font-scale="2"></b-icon>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'TI000034' } }"
          >
            2. 護生與放生／淨空法師　主講
            <b-icon icon="music-player" font-scale="2"></b-icon>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'T008W' } }"
          >
            3. 戒殺放生文／道源法師　主講
            <b-icon icon="music-player" font-scale="2"></b-icon>
          </b-list-group-item>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :to="{ name: 'series', params: { series_no: 'T010E' } }"
          >
            4. 我與小動物的故事／楊淑芬老師　主講
            <b-icon icon="music-player" font-scale="2"></b-icon>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import { IconsPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'

Vue.use(IconsPlugin)
Vue.use(ListGroupPlugin)

export default {
  name: "audiovisual",
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>